import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const AROpenItemsResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "EB98DFDD-A8D4-4D65-AE3A-6B74CA5BAF61";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                height="100%"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter enabled={true} visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="transactionnumber" caption='TransactionNumber' ></Column>
                <Column dataField="transactiontype" caption='Transaction Type' ></Column>
                <Column dataField="transactiondate" dataType="date" format="MM/dd/yyyy" caption='Transaction date' ></Column>
                <Column dataField="transactionduedate" dataType="date" format="MM/dd/yyyy" caption='Transaction Duedate' ></Column>
                <Column dataField="originalAmount" format={{
                    type: 'currency',
                    precision: 2
                }} caption='Balance' ></Column>
                <Column dataField="status" caption='Status' visible={false} ></Column>
                <Column dataField="invoiceNumber" caption='Invoice#' visible={false}  ></Column>
                <Column dataField="comment" caption='Comment' visible={false} ></Column>
                <Column dataField="description" caption='Description' ></Column>
                <Column dataField="name" caption='Name' ></Column>
                <Column dataField="calculatedPaid" format={{
                    type: 'currency',
                    precision: 2
                }} caption='Calculated Paid' visible={false} ></Column>
                <Column dataField="adjustments" format={{
                    type: 'currency',
                    precision: 2
                }} caption='Adjustments' visible={false} ></Column>
                <Column dataField="creationdatetime" caption="Creation datetime" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lastupdatedatetime" caption="Lastupdate datetime" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="creationuserid" caption='Creation Userid' visible={false} ></Column>
                <Column dataField="lastupdateuserid" caption='Lastupdate userid' visible={false} ></Column>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AROpenItemsResult);